<template>
	<div>
		<v-toolbar
			color="secondary"
			dark
			tabs
			height="100px"
		>
			<v-container
				py-o
				my-0
			>
				<v-toolbar-title class="display-2 ma-0">Page Not Found</v-toolbar-title>
			</v-container>
		</v-toolbar>
		<v-container
			grid-list-xl
		>
			<v-layout
				row
				wrap
				justify-center
				align-center
				class="text-xs-center"
			>
				<v-flex
					xs12
					md8
				>
					<v-card class="pa-3">
						<div class="headline">Sorry, the page you are looking for does not exist.</div>
						<v-btn
							flat
							color="success"
							@click="goBack()"
						>
							{{ backText }}
						</v-btn>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
export default {
	data() {
		return {
			backText: 'Take Me Back',
		};
	},
	created() {
		if (this.$route.params.to) {
			this.backText = 'Take Me Home';
		}
	},
	methods: {
		goBack() {
			if (this.$route.params.to) {
				this.$router.replace(this.$route.params.to);
			}
			else {
				this.$router.back();
			}
		},
	},
};
</script>

<style>

</style>
